var symphony = symphony || {};

;(function() {

  symphony.thumbnailSlider = function() {

  	var sliderContainer = $('.thumbnailSlider'),
  		sliderNav = $('.thumbnailSlider-nav');

  	if(typeof sliderContainer == 'undefined' || typeof sliderNav == 'undefined') {
  		return;
  	}

	sliderContainer.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: true,
		asNavFor: '.thumbnailSlider-nav',
		lazyLoad: 'ondemand'
	});

	sliderNav.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		asNavFor: '.thumbnailSlider',
		dots: false,
		arrows:false,
		centerMode: true,
		focusOnSelect: true,
		variableWidth: true,
		lazyLoad: 'ondemand'
	});


  };


})();